module.exports = __webpack_public_path__ + "static/media/img_4-3a_retreat.360dc4cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/media/img_4-3a_retreat.png
// module id = 693
// module chunks = 0